import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  Checkbox,
  InputSize,
  InputText,
  SelectSize,
} from '@ui/src';
import AdditionalInfoBlock from '../additional-info-block';
import { CorrespondenceAddressTypes } from './types';
import { CustomerStatus } from '../../../../../hoc/common/types';
import RegulatedCompanyRow from '../corporate-questionnarie/row';

import cn from '../corporate-questionnarie/styles.module.css';

const CorrespondenceAddress = ({
  organizationControl,
  organizationSetValue,
  status,
  organizationFields,
  countries,
  organizationClearErrors,
  organizationErrors,
}: CorrespondenceAddressTypes) => (
  <AdditionalInfoBlock title="Correspondence address">
    <div className={cn.addressCheckboxWrapper}>
      <Controller
        control={organizationControl}
        name="correspondenceAddressSameAsRegisteredAddress"
        defaultValue={false}
        render={({ field: { onChange, value } }) => (
          <Checkbox
            name="correspondenceAddressSameAsRegisteredAddress"
            type="checkbox"
            checked={value}
            onChange={(e) => {
              onChange(e.target.checked);

              if (e.target.checked && organizationSetValue) {
                organizationSetValue('correspondenceAddress1', '');
                organizationSetValue('correspondenceAddress2', '');
                organizationSetValue('correspondenceCity', '');
                organizationSetValue('correspondenceCountryId', '');
                organizationSetValue('correspondencePostalCode', '');
              }
            }}
            title="Coincides with the registered address"
            disabled={status === CustomerStatus.CLOSED}
            tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
            labelClassName={cn.addressCheckbox}
          />
        )}
      />
    </div>
    {!organizationFields?.correspondenceAddressSameAsRegisteredAddress && (
      <>
        <RegulatedCompanyRow title="Country">
          <Controller
            control={organizationControl}
            name="correspondenceCountryId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                name="correspondenceCountryId"
                placeholder="Select country..."
                list={countries}
                value={value}
                size={SelectSize.SMALL}
                selectWrapperClassName={
                  status === CustomerStatus.CLOSED ? cn.selectDisabled : ''
                }
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                onChange={(e) => {
                  onChange(e);

                  if (organizationClearErrors) {
                    organizationClearErrors(['correspondenceCountryId']);
                  }
                }}
                error={organizationErrors?.correspondenceCountryId?.message}
                borderless
                fullWidth
              />
            )}
          />
        </RegulatedCompanyRow>
        <RegulatedCompanyRow title="City">
          <Controller
            control={organizationControl}
            name="correspondenceCity"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="correspondenceCity"
                placeholder="Enter city..."
                value={value}
                onChange={(e) => {
                  onChange(e);

                  if (organizationClearErrors) {
                    organizationClearErrors(['correspondenceCity']);
                  }
                }}
                size={InputSize.SMALL}
                className="borderless"
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                error={organizationErrors?.correspondenceCity?.message}
              />
            )}
          />
        </RegulatedCompanyRow>
        <RegulatedCompanyRow title="Postal code">
          <Controller
            control={organizationControl}
            name="correspondencePostalCode"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="correspondencePostalCode"
                placeholder="Enter postal code..."
                value={value}
                onChange={(e) => {
                  onChange(e);

                  if (organizationClearErrors) {
                    organizationClearErrors(['correspondencePostalCode']);
                  }
                }}
                size={InputSize.SMALL}
                className="borderless"
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                error={organizationErrors?.correspondencePostalCode?.message}
              />
            )}
          />
        </RegulatedCompanyRow>
        <RegulatedCompanyRow title="Address 1">
          <Controller
            control={organizationControl}
            name="correspondenceAddress1"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="correspondenceAddress1"
                placeholder="Enter address 1..."
                value={value}
                onChange={(e) => {
                  onChange(e);

                  if (organizationClearErrors) {
                    organizationClearErrors(['correspondenceAddress1']);
                  }
                }}
                size={InputSize.SMALL}
                className="borderless"
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                error={organizationErrors?.correspondenceAddress1?.message}
              />
            )}
          />
        </RegulatedCompanyRow>
        <RegulatedCompanyRow title="Address 2">
          <Controller
            control={organizationControl}
            name="correspondenceAddress2"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="correspondenceAddress2"
                placeholder="Enter address 2..."
                value={value}
                onChange={(e) => {
                  onChange(e);

                  if (organizationClearErrors) {
                    organizationClearErrors(['correspondenceAddress2']);
                  }
                }}
                size={InputSize.SMALL}
                disabled={status === CustomerStatus.CLOSED}
                tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
                className="borderless"
                error={organizationErrors?.correspondenceAddress2?.message}
              />
            )}
          />
        </RegulatedCompanyRow>
      </>
    )}
  </AdditionalInfoBlock>
);

export default CorrespondenceAddress;
